import React, { Component } from 'react';

class Map extends Component {
    constructor(props) {
        super(props);
        this.onScriptLoad = this.onScriptLoad.bind(this)
    }

    onScriptLoad() {
        const map = new window.google.maps.Map(
            document.getElementById(this.props.id),
            this.props.options);
        this.props.onMapLoad(map);
    }

    componentDidMount() {
        if (!window.google) {
            let s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = `https://maps.google.com/maps/api/js?key=YOUR_API_KEY`;
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
            // Below is important.
            //We cannot access google.maps until it's finished loading
            s.addEventListener('load', e => {
                this.onScriptLoad()
            })
        } else {
            this.onScriptLoad()
        }
    }

    componentWillUnmount() {
        window.google.maps.event.clearListeners(this, 'idle');
        window.google.maps.event.clearListeners(this, 'polygoncomplete');
    }

    render() {
        return (
            <div style={{ width: '100%', height: this.props.height }} id={this.props.id} />
        );
    }
}

export default Map


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/Map.js